import Badge from '../ui/Badge.jsx'
import { REPOSITORY_CONTEXT } from '../../config/workspaceConfig.js'

export default function MaturityContext() {
  return (
    <section className="maturity-context" aria-label="Application data and maturity context">
      <div className="maturity-item maturity-repository">
        <span>Repository candidate</span>
        <strong title={REPOSITORY_CONTEXT.packVersion}>{REPOSITORY_CONTEXT.packVersion}</strong>
        <Badge tone="warning">{REPOSITORY_CONTEXT.knowledgeStatus}</Badge>
      </div>
      <div className="maturity-item"><span>Live data</span><strong>{REPOSITORY_CONTEXT.liveDatabase}</strong><Badge tone="info">Live database</Badge></div>
      <div className="maturity-item"><span>Installed release</span><strong>{REPOSITORY_CONTEXT.installedRelease}</strong></div>
      <div className="maturity-item"><span>Identification runtime</span><strong>{REPOSITORY_CONTEXT.runtimeStatus}</strong></div>
    </section>
  )
}
